module.exports = __webpack_public_path__ + "img/testimonials-bg.d8e03f09.jpeg";